<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <h3 class="page-title">{{ $tc('suppliers.view_supplier') }}</h3>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <router-link slot="item-title" to="/anchor/dashboard">{{ $t('general.home') }}</router-link>
            </li>
            <li class="breadcrumb-item">
                <router-link slot="item-title" to="/anchor/suppliers">  {{ $tc('suppliers.supplier',2) }}</router-link>
            </li>
            <li class="breadcrumb-item">
                <a  href="#/" slot="item-title" @click="viewSupplierPage" >{{ $tc('suppliers.view_supplier') }}</a>
            </li>
          </ol>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-12 align-self-center" >
          <h3 class="text-center" v-if="viewSupplier && viewSupplier.name !=null">{{ viewSupplier.name }}</h3>
        </div>
      </div>

    </div>
    <div class="row settings-container">
      <div class="col-lg-4 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in finalMenuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li>
        </ol>
      </div>
      <div class="col-lg-8">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
        id:null,
        userType:null,
        finalMenuItems:[],
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue ===  `/anchor/suppliers/${this.$route.params.id}/view`) {
        this.$router.push( `/anchor/suppliers/${this.$route.params.id}/view/basic-info`)
      }
    }
  },
  computed: {
    ...mapGetters('supplier', [
      'viewSupplier'
    ]),
  },
  created () {
    if(this.viewSupplier ==null){
       let res =  this.fetchViewSupplier(this.$route.params.id)
    }
    if (this.$route.path === `/anchor/suppliers/${this.$route.params.id}/view`) {
        this.$router.push( `/anchor/suppliers/${this.$route.params.id}/view/basic-info`)
    }
   if(localStorage.getItem('account_type')=='anchor'){
       this.userType='anchor';
        this.finalMenuItems= [
            {
            link: `/anchor/suppliers/${this.$route.params.id}/view/basic-info`,
            title: 'suppliers.basic_info',
            icon: 'info-circle',
            iconType: 'fa'
            },
            {
            link: `/anchor/suppliers/${this.$route.params.id}/view/billing-address`,
            title: 'suppliers.billing_address',
            icon: 'address-card',
            iconType: 'fa'
            },
            {
            link:  `/anchor/suppliers/${this.$route.params.id}/view/shipping-address`,
            title: 'suppliers.shipping_address',
            icon: 'address-book',
            iconType: 'fa'
            },
            {
            link:  `/anchor/suppliers/${this.$route.params.id}/view/supplier-process`,
            title: 'suppliers.supplier_process',
            icon: 'percentage',
            iconType: 'fa'
            },
        ];
    }
  },
  methods: {
    ...mapActions('supplier', [
      'fetchViewSupplier'
    ]),
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    },
    viewSupplierPage(){
       if(localStorage.getItem('account_type')=='anchor'){
            this.$router.push(`/anchor/suppliers/${this.$route.params.id}/view`)
        }
    }
  }
}
</script>
